import { initializerTypes } from '../actions/_initializer_actions';

const initialState = {
  loadPostulations: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case initializerTypes.UPDATE_PLATFORM_DATA:
      return {
        ...state,
        ...action.data,
      };
    case initializerTypes.GET_PLATFORM_DATA:
      return {
        skills: action.data,
      };
    case initializerTypes.LOAD_POSTULATIONS:
      return {
        ...state,
        loadPostulations: action.payload,
      };
    default:
      return state;
  }
};
